import { useCallback, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useAuth } from './useAuth';
import { flushAllPendingAutosaves, showError } from '@/lib/apiErrors';

export function useSignOut() {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const [signingOut, setSigningOut] = useState(false);

  const run = useCallback(async () => {
    if (signingOut) return;
    setSigningOut(true);
    try {
      // While the token is still valid; bounded so a hung request can't block sign-out.
      await Promise.race([
        flushAllPendingAutosaves(),
        new Promise((resolve) => setTimeout(resolve, 3000)),
      ]);
      try {
        await signOut();
      } catch {
        showError('Could not sign out. Check your connection and try again.');
        return;
      }
      await navigate({ to: '/login', replace: true });
    } finally {
      setSigningOut(false);
    }
  }, [signOut, navigate, signingOut]);

  return { signOut: run, signingOut };
}
